import { Form, Header } from 'semantic-ui-react';
import { Formik, FormikHelpers, FormikProps } from 'formik';
import './VerificationCodeForm.less';

interface VerificationCodeFormFields {
	code: string;
}

interface VerificationCodeFormProps {
	email?: string;
	onSubmit: (
		values: VerificationCodeFormFields,
		actions: FormikHelpers<VerificationCodeFormFields>
	) => void;
	renderActionButtons?: (isSubmitting: boolean) => React.ReactNode;
}

export const VerificationCodeForm: React.FC<VerificationCodeFormProps> = ({
	email,
	onSubmit,
	renderActionButtons,
}) => {
	return (
		<Formik
			onSubmit={onSubmit}
			initialValues={{
				code: '',
			}}
			validate={(values: VerificationCodeFormFields) => {
				const errors: Partial<VerificationCodeFormFields> = {};

				if (!values.code) {
					errors.code = 'Verification code is required.';
				} else if (values.code.length !== 7) {
					errors.code =
						'Verification code should be exactly 7 characters in length.';
				}

				return errors;
			}}
		>
			{({
				values,
				errors,
				touched,
				handleChange,
				handleBlur,
				handleSubmit,
				isSubmitting,
			}: FormikProps<VerificationCodeFormFields>) => (
				<Form className='verification-code-form' onSubmit={handleSubmit}>
					<Header as='h3'>Check your email</Header>
					<p>
						We’ve emailed a confirmation code {email && 'to your ' + email}.
						Enter it below to confirm your email address.
					</p>
					<div className='form-fields'>
						<Form.Input
							autoFocus
							fluid
							type='text'
							name='code'
							label='Your confirmation code'
							placeholder='ABCD123'
							onChange={handleChange}
							onBlur={handleBlur}
							value={values.code}
							error={!!(touched.code && errors.code)}
							required
						/>
						<small>The code we sent to your email address.</small>
					</div>
					{renderActionButtons && renderActionButtons(isSubmitting)}
				</Form>
			)}
		</Formik>
	);
};
